import React, { useEffect, useState } from "react";
import { User, Role } from "../common/ObjectTypes";
import { getUsers, searchUsers } from "../../api/users/usersApi";
import { toast } from "react-toastify";
import { MoonLoader } from "react-spinners";
import UsersList from "./UsersList";
import { getRoles } from "../../api/roles/rolesApi";
import { getOrganizations } from "../../api/organizations/organizationsApi";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../../helpers/authHeader";

const ManagePopulationTrendController = () => {
  const [pageLoaded, setPageLoaded] = useState(false);
  const navigate = useNavigate();
  const [users, setUsers] = useState<User[]>([]);
  const [roles, setRoles] = useState<Role[]>([]);
  const currentUser = getCurrentUser();
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);

  const [reloadPage, setReloadPage] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [recordStart, setRecordStart] = useState(0);
  const [recordEnd, setRecordEnd] = useState(0);
  const pageSize = 25;
  const [searchQuery, setSearchQuery] = useState({
    name: "",
    pageNumber: 1,
    pageSize,
    // selectVideoCataloguesPage ? pageSize : 25,
  });

  useEffect(() => {
    const loadUsers = async () => {
      setLoading(true);
      try {
        const temp = await searchUsers(searchQuery);
        setUsers(temp.results);
        loadRoles();
        loadOrgs();
        setPageCount(Math.ceil(temp.totalCount / pageSize));
        setTotalCount(temp.totalCount);
        const start = (searchQuery.pageNumber - 1) * searchQuery.pageSize + 1;
        const end = Math.min(start + temp.results.length - 1, temp.totalCount);

        setRecordStart(start);
        setRecordEnd(end);
        setPageLoaded(true);
        setReloadPage(false);
        setPageLoaded(true);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    const loadRoles = async () => {
      try {
        const temp = await getRoles();
        setRoles(temp);
      } catch (err) {
        console.log(err);
      }
    };

    const loadOrgs = async () => {
      try {
        const temp = await getOrganizations();
        setOrganizations(temp);
      } catch (err) {
        console.log(err);
      }
    };

    loadUsers();
  }, [pageLoaded, reloadPage]);

  const handleSelectUser = (id: string) => {
    navigate("/user/" + id + "/edit");
  };

  const handleOnClickAdd = () => {
    navigate("/user/add");
  };

  const handlePageClick = (selectedItem: { selected: number }) => {
    setSearchQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: selectedItem.selected + 1,
    }));
    setReloadPage(true);
  };

  return !pageLoaded ? (
    <div>
      <MoonLoader color="#9EB45B" />
    </div>
  ) : (
    <div className="h-full">
      <UsersList
        users={users}
        roles={roles}
        organizations={organizations}
        onSelectUser={handleSelectUser}
        onClickAdd={handleOnClickAdd}
        searchQuery={searchQuery}
        pageCount={pageCount}
        pageSize={pageSize}
        totalCount={totalCount}
        handlePageClick={handlePageClick}
        reloadPage={reloadPage}
        recordStart={recordStart}
        recordEnd={recordEnd}
        loading={loading}
      />
    </div>
  );
};

export default ManagePopulationTrendController;
